import { render, staticRenderFns } from "./ClinicAndOrganizationDetails.vue?vue&type=template&id=54565b24&scoped=true&"
import script from "./ClinicAndOrganizationDetails.vue?vue&type=script&lang=js&"
export * from "./ClinicAndOrganizationDetails.vue?vue&type=script&lang=js&"
import style0 from "./ClinicAndOrganizationDetails.vue?vue&type=style&index=0&id=54565b24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54565b24",
  null
  
)

export default component.exports